<app-card padding="0" [showHeader]="false">
    <div #mapContainer class="map-container" >
        <div #mapElement id="map" class="map-element"></div>
    </div>
</app-card>

